import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../utils/api';
import { Spinner, Empty, ConfirmModal } from '../components/UI';

export default function Catalogo() {
  const navigate = useNavigate();
  const [servicios, setServicios] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [busqueda, setBusqueda] = useState('');
  const [nuevo, setNuevo] = useState({ nombre: '', precio: '', link_ml: '' });
  const [tareasNuevo, setTareasNuevo] = useState([]);
  const [repuestosNuevo, setRepuestosNuevo] = useState([]);
  const [sugiriendo, setSugiriendo] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [editando, setEditando] = useState(null);
  const [tareasEditando, setTareasEditando] = useState([]);
  const [repuestosEditando, setRepuestosEditando] = useState([]);

  const [seleccionados, setSeleccionados] = useState([]);
  const [confirmandoBorrarML, setConfirmandoBorrarML] = useState(false);
  const [confirmandoBorrarSeleccion, setConfirmandoBorrarSeleccion] = useState(false);

  const cargar = () => {
    api('/servicios/').then(res => { setServicios(res); setCargando(false); setSeleccionados([]); });
  };

  useEffect(() => { cargar(); }, []);

  // Normaliza texto para buscar sin importar tildes ni mayúsculas/minúsculas
  const normalizar = (txt) => (txt || '')
    .toString()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  const totalServicios = servicios.length;
  const totalML = servicios.filter(s => s.link_ml).length;
  const totalOtros = totalServicios - totalML;

  const terminoBusqueda = normalizar(busqueda.trim());
  const serviciosFiltrados = terminoBusqueda
    ? servicios.filter(s =>
        normalizar(s.nombre).includes(terminoBusqueda) ||
        (s.tareas || []).some(t => normalizar(t.descripcion).includes(terminoBusqueda)) ||
        (s.repuestos || []).some(r => normalizar(r.nombre).includes(terminoBusqueda))
      )
    : servicios;

  const toggleSeleccion = (id) => {
    setSeleccionados(s => s.includes(id) ? s.filter(x => x !== id) : [...s, id]);
  };

  const borrarSoloML = async () => {
    await api('/servicios/solo-importados-ml', { method: 'DELETE' });
    setConfirmandoBorrarML(false);
    cargar();
  };

  const borrarSeleccionados = async () => {
    await api('/servicios/eliminar-multiples', { method: 'POST', body: JSON.stringify(seleccionados) });
    setConfirmandoBorrarSeleccion(false);
    cargar();
  };

  const sugerirRepuestos = async () => {
    if (!nuevo.nombre.trim()) return;
    setSugiriendo(true);
    try {
      const res = await api('/importar/sugerir-repuestos', {
        method: 'POST',
        body: JSON.stringify({ descripcion_servicio: nuevo.nombre })
      });
      setRepuestosNuevo((res.repuestos || []).map(r => ({ nombre: r.nombre, detalle: r.detalle || '' })));
    } catch { }
    setSugiriendo(false);
  };

  const agregar = async () => {
    if (!nuevo.nombre.trim()) return;
    setGuardando(true);
    try {
      await api('/servicios/', {
        method: 'POST',
        body: JSON.stringify({
          nombre: nuevo.nombre,
          precio: parseFloat(nuevo.precio) || 0, link_ml: nuevo.link_ml || null,
          tareas: tareasNuevo.filter(t => t.descripcion.trim()),
          repuestos: repuestosNuevo.filter(r => r.nombre.trim()),
        })
      });
      setNuevo({ nombre: '', precio: '', link_ml: '' });
      setTareasNuevo([]);
      setRepuestosNuevo([]);
      cargar();
    } catch { }
    setGuardando(false);
  };

  const empezarEdicion = (s) => {
    setEditando({ ...s });
    setTareasEditando(s.tareas && s.tareas.length > 0 ? s.tareas.map(t => ({ ...t })) : []);
    setRepuestosEditando(s.repuestos && s.repuestos.length > 0 ? s.repuestos.map(r => ({ ...r })) : []);
  };

  const guardarEdicion = async (id) => {
    await api(`/servicios/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({
        nombre: editando.nombre,
        precio: parseFloat(editando.precio) || 0, link_ml: editando.link_ml,
        tareas: tareasEditando.filter(t => t.descripcion.trim()),
        repuestos: repuestosEditando.filter(r => r.nombre.trim()),
      })
    });
    setEditando(null);
    setTareasEditando([]);
    setRepuestosEditando([]);
    cargar();
  };

  const eliminar = async (id) => {
    await api(`/servicios/${id}`, { method: 'DELETE' });
    cargar();
  };

  const actualizarTareaNuevo = (i, valor) => setTareasNuevo(t => t.map((x, idx) => idx === i ? { descripcion: valor } : x));
  const eliminarTareaNuevo = (i) => setTareasNuevo(t => t.filter((_, idx) => idx !== i));
  const agregarTareaNuevo = () => setTareasNuevo(t => [...t, { descripcion: '' }]);

  const actualizarRepuestoNuevo = (i, campo, valor) => {
    setRepuestosNuevo(r => r.map((x, idx) => idx === i ? { ...x, [campo]: valor } : x));
  };
  const eliminarRepuestoNuevo = (i) => setRepuestosNuevo(r => r.filter((_, idx) => idx !== i));
  const agregarRepuestoNuevo = () => setRepuestosNuevo(r => [...r, { nombre: '', detalle: '' }]);

  const actualizarTareaEditando = (i, valor) => setTareasEditando(t => t.map((x, idx) => idx === i ? { descripcion: valor } : x));
  const eliminarTareaEditando = (i) => setTareasEditando(t => t.filter((_, idx) => idx !== i));
  const agregarTareaEditando = () => setTareasEditando(t => [...t, { descripcion: '' }]);

  const actualizarRepuestoEditando = (i, campo, valor) => {
    setRepuestosEditando(r => r.map((x, idx) => idx === i ? { ...x, [campo]: valor } : x));
  };
  const eliminarRepuestoEditando = (i) => setRepuestosEditando(r => r.filter((_, idx) => idx !== i));
  const agregarRepuestoEditando = () => setRepuestosEditando(r => [...r, { nombre: '', detalle: '' }]);

  return (
    <div className="page-content">
      <div className="sec-header">
        <h1 className="page-title" style={{ marginBottom: 0 }}>Catálogo de servicios</h1>
        <div style={{ display: 'flex', gap: '.5rem', flexWrap: 'wrap' }}>
          {seleccionados.length > 0 && (
            <button className="btn btn-outline btn-sm" style={{ color: 'var(--rojo)' }}
              onClick={() => setConfirmandoBorrarSeleccion(true)}>
              🗑️ Borrar {seleccionados.length} seleccionado(s)
            </button>
          )}
          {servicios.some(s => s.link_ml) && (
            <button className="btn btn-outline btn-sm" style={{ color: 'var(--rojo)' }}
              onClick={() => setConfirmandoBorrarML(true)}>
              🗑️ Borrar todo lo de Mercado Libre
            </button>
          )}
          <button className="btn btn-outline btn-sm" onClick={() => navigate('/catalogo/importar-ml')}>
            📥 Importar desde Mercado Libre
          </button>
        </div>
      </div>

      {confirmandoBorrarML && (
        <ConfirmModal
          mensaje="¿Borrar todos los servicios importados desde Mercado Libre? Los que cargaste a mano (sin link de ML) no se tocan. No se puede deshacer."
          onConfirm={borrarSoloML}
          onCancel={() => setConfirmandoBorrarML(false)}
        />
      )}

      {confirmandoBorrarSeleccion && (
        <ConfirmModal
          mensaje={`¿Borrar los ${seleccionados.length} servicio(s) seleccionado(s)? No se puede deshacer.`}
          onConfirm={borrarSeleccionados}
          onCancel={() => setConfirmandoBorrarSeleccion(false)}
        />
      )}
      <p style={{ color: 'var(--gris-4)', fontSize: '.875rem', marginBottom: '.75rem' }}>
        Estos son los servicios que aparecen cuando hacés clic en "Ver catálogo" al armar una orden o presupuesto.
        Las tareas y repuestos se cargan automáticamente junto con el servicio.
      </p>

      <div className="card" style={{ marginBottom: '1.25rem', display: 'flex', flexWrap: 'wrap', gap: '1rem', alignItems: 'center', justifyContent: 'space-between' }}>
        <p style={{ fontSize: '.875rem', color: 'var(--gris-5)' }}>
          <strong>{totalServicios}</strong> ítem{totalServicios === 1 ? '' : 's'} en el catálogo
          {totalServicios > 0 && (
            <span style={{ color: 'var(--gris-4)' }}> — <strong>{totalML}</strong> de Mercado Libre, <strong>{totalOtros}</strong> de otro origen</span>
          )}
        </p>
        <input className="form-input" placeholder="🔍 Buscar servicio, tarea o repuesto..." style={{ maxWidth: 320 }}
          value={busqueda} onChange={e => setBusqueda(e.target.value)} />
      </div>

      <div className="card" style={{ marginBottom: '1.5rem' }}>
        <p style={{ fontWeight: 600, marginBottom: '.75rem', color: 'var(--azul)' }}>Agregar nuevo servicio al catálogo</p>
        <div className="form-grid-2" style={{ marginBottom: '.75rem' }}>
          <div className="form-group">
            <label className="form-label">Nombre del servicio</label>
            <input className="form-input" placeholder="Ej: Limpieza del sistema de refrigeración"
              value={nuevo.nombre} onChange={e => setNuevo(p => ({ ...p, nombre: e.target.value }))} />
          </div>
          <div className="form-group">
            <label className="form-label">Precio (opcional)</label>
            <input type="number" className="form-input" placeholder="$"
              value={nuevo.precio} onChange={e => setNuevo(p => ({ ...p, precio: e.target.value }))} />
          </div>
        </div>
        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label className="form-label">Link de Mercado Libre (opcional, de referencia)</label>
          <input className="form-input" value={nuevo.link_ml}
            onChange={e => setNuevo(p => ({ ...p, link_ml: e.target.value }))} />
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <p style={{ fontWeight: 600, fontSize: '.875rem', color: 'var(--gris-5)', marginBottom: '.5rem' }}>Tareas incluidas</p>
          {tareasNuevo.map((t, i) => (
            <div key={i} style={{ display: 'flex', gap: '.4rem', marginBottom: '.3rem' }}>
              <input className="form-input" placeholder="Ej: Cambio de aceite de motor" style={{ flex: 1 }}
                value={t.descripcion} onChange={e => actualizarTareaNuevo(i, e.target.value)} />
              <button onClick={() => eliminarTareaNuevo(i)} style={{ background: 'none', border: 'none', color: 'var(--rojo)', cursor: 'pointer' }}>✕</button>
            </div>
          ))}
          <button className="btn btn-outline btn-sm" onClick={agregarTareaNuevo}>+ Agregar tarea</button>
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <div className="sec-header" style={{ marginBottom: '.5rem' }}>
            <p style={{ fontWeight: 600, fontSize: '.875rem', color: 'var(--gris-5)' }}>Repuestos / insumos que usa</p>
            <button className="btn btn-outline btn-sm" disabled={!nuevo.nombre.trim() || sugiriendo} onClick={sugerirRepuestos}>
              {sugiriendo ? '...' : '✨ Sugerir con IA'}
            </button>
          </div>
          {sugiriendo && <Spinner texto="Buscando repuestos típicos..." />}
          {repuestosNuevo.map((r, i) => (
            <div key={i} style={{ display: 'flex', gap: '.4rem', marginBottom: '.3rem' }}>
              <input className="form-input" placeholder="Nombre del repuesto/insumo" style={{ flex: 1 }}
                value={r.nombre} onChange={e => actualizarRepuestoNuevo(i, 'nombre', e.target.value)} />
              <input className="form-input" placeholder="Detalle (marca, tipo, unidades)" style={{ flex: 1 }}
                value={r.detalle} onChange={e => actualizarRepuestoNuevo(i, 'detalle', e.target.value)} />
              <button onClick={() => eliminarRepuestoNuevo(i)} style={{ background: 'none', border: 'none', color: 'var(--rojo)', cursor: 'pointer' }}>✕</button>
            </div>
          ))}
          <button className="btn btn-outline btn-sm" onClick={agregarRepuestoNuevo}>+ Agregar repuesto</button>
        </div>

        <button className="btn btn-primary" disabled={!nuevo.nombre.trim() || guardando} onClick={agregar}>
          {guardando ? 'Guardando...' : '+ Agregar al catálogo'}
        </button>
      </div>

      {cargando ? <Spinner texto="Cargando..." /> :
        servicios.length === 0 ? <Empty icon="📋" texto="Sin servicios en el catálogo todavía" /> :
        serviciosFiltrados.length === 0 ? <Empty icon="🔍" texto={`Sin resultados para "${busqueda}"`} /> :
        serviciosFiltrados.map(s => (
          <div key={s.id} className="card" style={{ marginBottom: '.75rem' }}>
            {editando?.id === s.id ? (
              <div>
                <input className="form-input" style={{ marginBottom: '.75rem', fontWeight: 600 }}
                  value={editando.nombre} onChange={e => setEditando(p => ({ ...p, nombre: e.target.value }))} />
                <input type="number" className="form-input" style={{ marginBottom: '.75rem', maxWidth: 150 }}
                  value={editando.precio} onChange={e => setEditando(p => ({ ...p, precio: e.target.value }))} />

                <p style={{ fontWeight: 600, fontSize: '.875rem', color: 'var(--gris-5)', marginBottom: '.4rem' }}>Tareas incluidas</p>
                {tareasEditando.map((t, i) => (
                  <div key={i} style={{ display: 'flex', gap: '.4rem', marginBottom: '.3rem' }}>
                    <input className="form-input" style={{ flex: 1 }}
                      value={t.descripcion} onChange={e => actualizarTareaEditando(i, e.target.value)} />
                    <button onClick={() => eliminarTareaEditando(i)} style={{ background: 'none', border: 'none', color: 'var(--rojo)', cursor: 'pointer' }}>✕</button>
                  </div>
                ))}
                <button className="btn btn-outline btn-sm" onClick={agregarTareaEditando} style={{ marginBottom: '.75rem' }}>+ Agregar tarea</button>

                <p style={{ fontWeight: 600, fontSize: '.875rem', color: 'var(--gris-5)', marginBottom: '.4rem' }}>Repuestos / insumos</p>
                {repuestosEditando.map((r, i) => (
                  <div key={i} style={{ display: 'flex', gap: '.4rem', marginBottom: '.3rem' }}>
                    <input className="form-input" placeholder="Nombre" style={{ flex: 1 }}
                      value={r.nombre} onChange={e => actualizarRepuestoEditando(i, 'nombre', e.target.value)} />
                    <input className="form-input" placeholder="Detalle" style={{ flex: 1 }}
                      value={r.detalle || ''} onChange={e => actualizarRepuestoEditando(i, 'detalle', e.target.value)} />
                    <button onClick={() => eliminarRepuestoEditando(i)} style={{ background: 'none', border: 'none', color: 'var(--rojo)', cursor: 'pointer' }}>✕</button>
                  </div>
                ))}
                <button className="btn btn-outline btn-sm" onClick={agregarRepuestoEditando} style={{ marginBottom: '.75rem' }}>+ Agregar repuesto</button>

                <div style={{ display: 'flex', gap: '.5rem' }}>
                  <button className="btn btn-secondary btn-sm" onClick={() => { setEditando(null); setTareasEditando([]); setRepuestosEditando([]); }}>Cancelar</button>
                  <button className="btn btn-primary btn-sm" onClick={() => guardarEdicion(s.id)}>Guardar</button>
                </div>
              </div>
            ) : (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '.6rem' }}>
                <input type="checkbox" checked={seleccionados.includes(s.id)} onChange={() => toggleSeleccion(s.id)}
                  style={{ marginTop: '.3rem' }} />
                <div style={{ flex: 1 }}>
                  <p style={{ fontWeight: 600 }}>
                    {s.nombre} {s.precio ? <span style={{ color: 'var(--azul)' }}>— ${s.precio.toLocaleString()}</span> : ''}
                    {s.link_ml && <span className="badge badge-gris" style={{ marginLeft: '.5rem', fontSize: '.7rem' }}>ML</span>}
                  </p>
                  {s.tareas && s.tareas.length > 0 && (
                    <ul style={{ marginTop: '.4rem', paddingLeft: '1.1rem', fontSize: '.875rem', color: 'var(--gris-5)' }}>
                      {s.tareas.map((t, i) => <li key={i}>{t.descripcion}</li>)}
                    </ul>
                  )}
                  {s.repuestos && s.repuestos.length > 0 && (
                    <p style={{ fontSize: '.8125rem', color: 'var(--gris-4)', marginTop: '.4rem', fontStyle: 'italic' }}>
                      Repuestos: {s.repuestos.map(r => r.nombre + (r.detalle ? ` (${r.detalle})` : '')).join(', ')}
                    </p>
                  )}
                </div>
                <div style={{ display: 'flex', gap: '.4rem', flexShrink: 0 }}>
                  <button className="btn btn-outline btn-sm" onClick={() => empezarEdicion(s)}>Editar</button>
                  <button className="btn btn-outline btn-sm" style={{ color: 'var(--rojo)' }} onClick={() => eliminar(s.id)}>Eliminar</button>
                </div>
              </div>
            )}
          </div>
        ))
      }
    </div>
  );
}
